import { render, staticRenderFns } from "./stationeryAdd.vue?vue&type=template&id=a634ab24&scoped=true"
import script from "./stationeryAdd.vue?vue&type=script&lang=js"
export * from "./stationeryAdd.vue?vue&type=script&lang=js"
import style0 from "./stationeryAdd.vue?vue&type=style&index=0&id=a634ab24&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a634ab24",
  null
  
)

export default component.exports